import React from 'react';
import Modal from 'react-modal';
import './VideoModal.css'
import { AiOutlineClose } from 'react-icons/ai';


interface VideoModalProps {
    isOpen: boolean;
    onClose: () => void;
    videoId: string;
    videoTitle: string
}


export default function VideoModal(props: VideoModalProps) {
    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.onClose}
            contentLabel="Video Modal"
        >
            <button onClick={props.onClose} className="close-icon">
                <AiOutlineClose />
            </button>
            <div className='video-container'>
                <iframe src={`https://www.youtube.com/embed/${props.videoId}`} title={props.videoTitle} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>≈
            </div>
        </Modal>
    );
};